const translation = {
  // Navigation
  'nav.home': 'الرئيسية',
  'nav.about': 'من نحن',
  'nav.directory': 'الدليل المهني',
  'nav.knowledge': 'مركز المعرفة',
  'nav.impact': 'التأثير العالمي',
  'nav.contact': 'اتصل بنا',
  'nav.join': 'انضم إلينا',

  // Hero Section
  'hero.title': 'شبكة دعم مهنية للاندماج في هولندا',
  'hero.subtitle': 'تقديم الدعم المادي والمعنوي للأشخاص من جميع الأعراق واللغات والأديان والمعتقدات في كل مرحلة من مخيم اللاجئين إلى الحصول على الجنسية',
  'hero.cta.primary': 'انضم إلى شبكتنا',
  'hero.cta.secondary': 'استكشف المزيد',

  // About Section
  'about.title': 'من نحن',
  'about.subtitle': 'مجتمع عالمي يدعم الاندماج لكل من يأتي إلى هولندا',
  'about.mission.title': 'مهمتنا',
  'about.mission.text': 'تهدف مؤسسة IPN إلى تقديم دعم مادي ومعنوي شامل للأشخاص من جميع الأعراق واللغات والأديان والمعتقدات القادمين إلى هولندا، من وصولهم إلى مخيمات اللاجئين خلال فترة الانتظار، والعثور على السكن، والحصول على الجنسية وما بعدها، لضمان الاندماج الناجح في المجتمع الهولندي.',
  'about.vision.title': 'رؤيتنا',
  'about.vision.text': 'خلق مجتمع في هولندا حيث يتمتع الجميع بفرص متساوية، ويُنظر إلى التنوع الثقافي على أنه ثروة، ويتحقق الاندماج بنجاح.',
  'about.values.title': 'قيمنا',
  'about.values.text': 'الشمولية والتضامن والمهنية والمسؤولية الاجتماعية هي الأسس التي تقوم عليها منظمتنا، وتنعكس في كل ما نقوم به.',

  // Core Values
  'values.title': 'قيمنا الأساسية',
  'values.subtitle': 'المبادئ التي توجه عملنا',
  'values.ethics.title': 'الشمولية',
  'values.ethics.text': 'دعم واحترام متساوٍ للأشخاص من جميع الأعراق واللغات والأديان والمعتقدات',
  'values.wisdom.title': 'التضامن',
  'values.wisdom.text': 'ثقافة التماسك الاجتماعي والمساعدة المتبادلة',
  'values.service.title': 'الدعم المهني',
  'values.service.text': 'دعم الاندماج من خلال التوجيه المتخصص والحلول العملية',
  'values.impact.title': 'التأثير الاجتماعي',
  'values.impact.text': 'خلق تغيير دائم وذو مغزى في المجتمع الهولندي',

  // Professional Directory
  'directory.title': 'الدليل المهني',
  'directory.subtitle': 'تواصل مع الخبراء الذين يمكنهم مساعدتك في عملية الاندماج',
  'directory.search': 'البحث عن محترفين...',
  'directory.filter.all': 'جميع المجالات',
  'directory.filter.education': 'التعليم',
  'directory.filter.healthcare': 'الرعاية الصحية',
  'directory.filter.technology': 'التكنولوجيا',
  'directory.filter.business': 'الأعمال',
  'directory.filter.law': 'القانون',
  'directory.filter.engineering': 'الهندسة',
  'directory.viewProfile': 'عرض الملف الشخصي',

  // Knowledge Hub
  'knowledge.title': 'مركز المعرفة والموارد',
  'knowledge.subtitle': 'أدلة ومقالات وموارد لعملية الاندماج الخاصة بك',
  'knowledge.featured': 'المنشورات المميزة',
  'knowledge.readMore': 'اقرأ المزيد',
  'knowledge.viewAll': 'عرض جميع المنشورات',

  // Global Impact
  'impact.title': 'برامج الدعم لدينا',
  'impact.subtitle': 'نحن معك في كل مرحلة من رحلة الاندماج الخاصة بك',
  'impact.education.title': 'دعم التعليم واللغة',
  'impact.education.text': 'دورات اللغة الهولندية، والاستشارات التعليمية، والتوجيه في عمليات معادلة الشهادات',
  'impact.healthcare.title': 'الدعم الصحي والاجتماعي',
  'impact.healthcare.text': 'التوجيه في نظام الرعاية الصحية، والدعم النفسي، وبرامج المساعدة الاجتماعية',
  'impact.research.title': 'دعم التوظيف والمهنة',
  'impact.research.text': 'البحث عن عمل، وإعداد السيرة الذاتية، والتدريب المهني، والاستشارات في مجال ريادة الأعمال',
  'impact.humanitarian.title': 'الدعم القانوني والإداري',
  'impact.humanitarian.text': 'التوجيه المهني في تصاريح الإقامة، وطلبات الجنسية، والإجراءات القانونية',

  // Testimonials
  'testimonials.title': 'من أعضائنا',
  'testimonials.subtitle': 'أصوات من مجتمعنا',

  // Contact
  'contact.title': 'تواصل معنا',
  'contact.subtitle': 'هل لديك أسئلة؟ نحن نحب أن نسمع منك',
  'contact.name': 'اسمك',
  'contact.email': 'بريدك الإلكتروني',
  'contact.subject': 'الموضوع',
  'contact.message': 'رسالتك',
  'contact.send': 'إرسال الرسالة',
  'contact.info.title': 'معلومات الاتصال',
  'contact.info.address': 'العنوان',
  'contact.info.phone': 'الهاتف',
  'contact.info.email': 'البريد الإلكتروني',

  // Footer
  'footer.about.title': 'حول مؤسسة IPN',
  'footer.about.text': 'شبكة مهنية تقدم دعمًا شاملاً لجميع الأشخاص القادمين إلى هولندا خلال عملية الاندماج.',
  'footer.quickLinks': 'روابط سريعة',
  'footer.connect': 'ابق على اتصال',
  'footer.newsletter': 'اشترك في نشرتنا الإخبارية',
  'footer.newsletter.placeholder': 'أدخل بريدك الإلكتروني',
  'footer.newsletter.button': 'اشترك',
  'footer.copyright': '© 2024 مؤسسة IPN. جميع الحقوق محفوظة.',
  'footer.privacy': 'سياسة الخصوصية',
  'footer.terms': 'شروط الخدمة',

  contact: {
    form: {
      name: 'الاسم',
      namePlaceholder: 'أدخل اسمك',
      email: 'البريد الإلكتروني',
      emailPlaceholder: 'أدخل بريدك الإلكتروني',
      phone: 'الهاتف',
      phonePlaceholder: 'أدخل رقم هاتفك',
      subject: 'الموضوع',
      subjectPlaceholder: 'موضوع رسالتك',
      message: 'الرسالة',
      messagePlaceholder: 'اكتب رسالتك هنا...',
      maxChars: 'الحد الأقصى 500 حرف',
      submit: 'إرسال الرسالة',
      sending: 'جاري الإرسال...',
      successMessage: 'تم إرسال رسالتك بنجاح! سنتواصل معك في أقرب وقت ممكن.',
      errorMessage: 'حدث خطأ. يرجى المحاولة مرة أخرى.',
    },
    workingHours: 'ساعات العمل',
    weekdays: 'أيام الأسبوع',
    weekend: 'عطلة نهاية الأسبوع',
    closed: 'مغلق',
  },
  news: {
    title: 'نظام تتبع أخبار اللاجئين',
    subtitle: 'تابع آخر الأخبار حول اللاجئين من IND و COA والبلديات ووسائل الإعلام. اشترك في نشرتنا الإخبارية الشهرية ولا تفوت التطورات المهمة.',
    subscribe: 'اشترك في النشرة الشهرية',
    new: 'جديد',
    readMore: 'اقرأ المزيد',
    categories: {
      all: 'الكل',
      municipality: 'البلديات',
      media: 'وسائل الإعلام',
      policy: 'السياسة',
    },
    items: {
      ind1: {
        title: 'IND تعلن عن إجراءات تقديم جديدة',
        summary: 'تقدم IND إجراءات جديدة وعمليات تقييم أسرع لطلبات اللجوء. تغييرات مهمة لمقدمي الطلبات.',
      },
      coa1: {
        title: 'COA تفتتح مراكز استقبال جديدة',
        summary: 'أعلنت COA عن افتتاح مراكز استقبال جديدة في جميع أنحاء هولندا للاستجابة للطلب المتزايد. زيادة السعة بنسبة 30٪.',
      },
      municipality1: {
        title: 'أمستردام توسع برامج الاندماج',
        source: 'بلدية أمستردام',
        summary: 'تزيد بلدية أمستردام الاستثمارات في دورات اللغة وبرامج التوظيف للاجئين. تمت الموافقة على الميزانية الجديدة.',
      },
      media1: {
        title: 'اندماج اللاجئين في هولندا: قصص نجاح',
        summary: 'أصدرت NOS فيلمًا وثائقيًا خاصًا حول أمثلة الاندماج الناجحة ومساهمات اللاجئين في المجتمع الهولندي.',
      },
      policy1: {
        title: 'الموافقة على قانون الاندماج الجديد في البرلمان',
        summary: 'وافق البرلمان الهولندي على قانون جديد يسهل ويدعم عملية الاندماج للاجئين. يدخل القانون حيز التنفيذ في 2024.',
      },
      ind2: {
        title: 'IND تطلق نظام التقديم الرقمي',
        summary: 'قدمت IND منصة جديدة تسمح بتقديم طلبات اللجوء رقميًا. العملية الآن أسرع وأكثر شفافية.',
      },
    },
    infoBox: {
      title: 'تتبع الأخبار التلقائي',
      description: 'يقوم نظامنا بمسح IND و COA و Overheid.nl والبلديات والمؤسسات الإعلامية الرائدة يوميًا ويجمع تلقائيًا الأخبار المهمة حول اللاجئين. اشترك في نشرتنا الإخبارية الشهرية للبقاء على اطلاع بجميع التطورات المهمة.',
    },
    modal: {
      title: 'اشترك في النشرة الشهرية',
      description: 'أدخل عنوان بريدك الإلكتروني واستقبل أهم الأخبار حول اللاجئين مباشرة في صندوق الوارد الخاص بك كل شهر.',
      emailLabel: 'عنوان البريد الإلكتروني',
      emailPlaceholder: 'example@email.com',
      subscribeButton: 'اشترك',
      subscribing: 'جاري الاشتراك...',
      successMessage: 'لقد اشتركت بنجاح! ستتلقى نشرتك الإخبارية الأولى قريبًا.',
      errorMessage: 'حدث خطأ. يرجى المحاولة مرة أخرى.',
    },
  },

  integration: {
    title: 'عملية الاندماج لدينا',
    subtitle: 'نحن معك في كل خطوة من وصولك إلى هولندا حتى الحصول على الجنسية. إليك العملية المكونة من 6 مراحل التي سنرشدك خلالها.',
    step: 'المرحلة',
    requiredDocuments: 'المستندات المطلوبة',
    tips: 'نصائح مهمة',
    getSupport: 'احصل على الدعم في هذه المرحلة',
    successTitle: 'اكتشف قصص النجاح',
    successDescription: 'أكمل آلاف الأشخاص هذه العملية بنجاح. استلهم من تجاربهم وانجح أنت أيضاً.',
    readStories: 'اقرأ القصص',
    
    steps: {
      step1: {
        shortTitle: 'الوصول',
        title: 'الوصول والتسجيل الأولي',
        description: 'التسجيل الأولي في تير آبل وترتيبات الإقامة المؤقتة',
        duration: '1-3 أيام',
        documents: [
          'جواز السفر أو وثيقة الهوية',
          'وثائق السفر',
          'وثائق التعليم والعمل إن وجدت',
          'وثائق تثبت الحالة العائلية'
        ],
        tips: [
          'احتفظ بجميع وثائقك في مكان آمن',
          'كن صادقاً ومنفتحاً في المقابلة الأولى',
          'استخدم خدمات الترجمة الفورية',
          'استمع بعناية للمعلومات المقدمة'
        ]
      },
      step2: {
        shortTitle: 'المقابلة',
        title: 'مقابلات IND',
        description: 'طلب اللجوء والمقابلات التفصيلية، رواية قصتك',
        duration: '6-12 شهراً',
        documents: [
          'وثائق الهوية والصور الفوتوغرافية',
          'وثائق تدعم أسباب مغادرة بلدك',
          'أدلة على التهديدات أو الاضطهاد إن وجدت',
          'وثائق تثبت الروابط العائلية'
        ],
        tips: [
          'احكِ قصتك بشكل متسق ومفصل',
          'أجب على جميع الأسئلة بعناية',
          'احصل على دعم قانوني',
          'استخدم خدمات الدعم النفسي'
        ]
      },
      step3: {
        shortTitle: 'الاستقرار',
        title: 'تصريح الإقامة والسكن',
        description: 'الحصول على تصريح الإقامة وتخصيص السكن الدائم، بداية حياتك الجديدة',
        duration: '2-6 أشهر',
        documents: [
          'قرار IND وتصريح الإقامة',
          'تسجيل BSN (رقم الخدمة المدنية)',
          'شهادة التأمين الصحي',
          'معلومات الحساب البنكي'
        ],
        tips: [
          'سجل في البلدية فوراً',
          'احصل على تأمين صحي (إلزامي)',
          'تقدم بطلب للحصول على المساعدة الاجتماعية',
          'تعرف على حيك وجيرانك'
        ]
      },
      step4: {
        shortTitle: 'التعليم',
        title: 'تدريب اللغة والاندماج',
        description: 'دورة اللغة الهولندية وبرامج الاندماج الاجتماعي، التكيف الثقافي',
        duration: '6-36 شهراً',
        documents: [
          'وثيقة تسجيل امتحان الاندماج',
          'شهادة حضور دورة اللغة',
          'تقارير التقدم التعليمي',
          'وثائق نتائج الامتحانات'
        ],
        tips: [
          'احضر الدورات بانتظام',
          'مارس اللغة الهولندية في المنزل أيضاً',
          'شارك في الفعاليات المحلية',
          'تقدم للعمل التطوعي'
        ]
      },
      step5: {
        shortTitle: 'التوظيف',
        title: 'البحث عن عمل ومسيرة مهنية',
        description: 'التدريب المهني، دعم البحث عن عمل وخدمات التخطيط الوظيفي',
        duration: '3-12 شهراً',
        documents: [
          'السيرة الذاتية وخطاب التحفيز',
          'شهادة معادلة الدبلوم',
          'وثائق التقديم للوظائف',
          'خطابات التوصية'
        ],
        tips: [
          'احصل على اعتراف بشهاداتك',
          'أعد سيرة ذاتية بالأسلوب الهولندي',
          'وسع شبكة علاقاتك المهنية',
          'فكر في فرص التدريب والعمل التطوعي'
        ]
      },
      step6: {
        shortTitle: 'الجنسية',
        title: 'الجنسية وما بعدها',
        description: 'طلب الجنسية الهولندية والاندماج الكامل في المجتمع',
        duration: '5+ سنوات',
        documents: [
          'وثيقة تصريح إقامة لمدة 5 سنوات',
          'شهادة نجاح امتحان الاندماج',
          'وثائق الدخل والضرائب',
          'شهادة السجل الجنائي'
        ],
        tips: [
          'استوفِ جميع المتطلبات القانونية',
          'أظهر مشاركة نشطة في المجتمع',
          'التزم بمسؤولياتك المالية',
          'تبنَّ القيم الهولندية'
        ]
      }
    }
  }
};

export default translation;